module.exports = __webpack_public_path__ + "img/logo-sd-jj.6aa66373.png";